import { render, staticRenderFns } from "./CoralsolManejosTable.vue?vue&type=template&id=19f60c90&"
import script from "./CoralsolManejosTable.vue?vue&type=script&lang=js&"
export * from "./CoralsolManejosTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports